export default __webpack_public_path__ + "static/media/SWT0970.34I-27987_-16771_0.007cab85.jpg";